import * as React from "react";

import { AiAgentThreadPubSubBus } from "./AiAgentThreadPubSubBus.ts";

export const useSubscribeToAiAgentThreadPubSubBus = <T = unknown>(
  topic: string,
  subscriber: (payload: T) => void,
): void => {
  // Memoize the subscriber to avoid unnecessary re-subscriptions
  const subscriberRef = React.useRef(subscriber);

  // Update the ref when subscriber changes
  React.useEffect(() => {
    subscriberRef.current = subscriber;
  }, [subscriber]);

  React.useEffect(() => {
    const bus = AiAgentThreadPubSubBus.getInstance();

    // Wrap the subscriber to use the ref, ensuring we always call the latest version
    const wrappedSubscriber = (payload: T) => {
      subscriberRef.current(payload);
    };

    const unsubscribe = bus.subscribe<T>(topic, wrappedSubscriber);

    return () => {
      unsubscribe();
    };
  }, [topic]);
};

export const usePublishToAiAgentThreadPubSubBus = <T = unknown>(
  topic: string,
): ((payload: T) => boolean) => {
  const bus = React.useMemo(() => AiAgentThreadPubSubBus.getInstance(), []);

  return React.useCallback(
    (payload: T) => {
      return bus.publish<T>(topic, payload);
    },
    [bus, topic],
  );
};
